import { EMEARegion, LARegion } from "@dana/Common/Constants";
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { GetBillTosApiParameter, GetShipTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import selectBillTo from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SelectBillTo";
import selectShipTo from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SelectShipTo";
import setAsDefault from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetAsDefault";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { SetCookie } from "@insite/client-framework/Store/Context/Handlers/SetShowPricing";
import { getBillTosDataView, getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import loadBillTos from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import loadShipTos from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTos";
import { getShipTosDataView, getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import ChangeCustomerBillToSelector, {
    ChangeCustomerBillToSelectorStyles,
} from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerBillToSelector";
import ChangeCustomerShipToSelector, {
    ChangeCustomerShipToSelectorStyles,
} from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerShipToSelector";
import  { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import  { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    billTosParameter: GetBillTosApiParameter;
    setBillTosParameter: (parameter: GetBillTosApiParameter) => void;
    shipTosParameter: GetShipTosApiParameter;
    setShipTosParameter: (parameter: GetShipTosApiParameter) => void;
    extendedStyles?: AddressDrawerSelectCustomerContainerStyles;
}

const mapStateToProps = (state: ApplicationState, props: OwnProps) => {
    const { fulfillmentMethod, selectedBillTo, selectedShipTo, isDefault } = state.components.addressDrawer;
    const { isAuthenticated, rememberMe, isGuest, shipToId, billToId,properties } = state.context.session;
    const {
        accountSettings: { enableWarehousePickup, requireSelectCustomerOnSignIn },
        customerSettings: { allowCreateNewShipToAddress },
    } = getSettingsCollection(state);
    const { displayChangeCustomerLink } = getSession(state);
    const session = getSession(state);    
    const currentLanguageId = session.language!.id;
    const currentRegion = state.context.website.languages!.languages!.find(lang => lang.id === currentLanguageId)?.properties?.region;
    const shipToState = getShipToState(state, shipToId);
    const { value: shipTo } = shipToState;
    const billToState = getBillToState(state, billToId);
    const { value: billTo } = billToState;
    
        const selId= getCookie("selectBillLa");
        let addressLabel ="";
        if((isAuthenticated || rememberMe) && !isGuest && shipTo && selId && billTo)
        {
            if(shipTo.id?.toString()===selId)
            {
                addressLabel = `${shipTo.customerSequence} ${shipTo.properties?.danaDealerCode ?? ""} ${shipTo.companyName} ${shipTo.city}, ${shipTo.state?.abbreviation ?? ""}`;
            }
            else if(billTo.id?.toString()===selId)
            {
                addressLabel = `${billTo.customerSequence} ${billTo.properties?.danaDealerCode ?? ""} ${billTo.companyName} ${billTo.city}, ${billTo.state?.abbreviation ?? ""}`;
            }           
        }        
    return {
        selectedBillTo,
        selectedShipTo,
        shipTosDataView: getShipTosDataView(state, props.shipTosParameter),
        billTosDataView: getBillTosDataView(state, props.billTosParameter),
        fulfillmentMethod,
        enableWarehousePickup,
        allowCreateNewShipToAddress,
        isDefault,
        showIsDefaultCheckbox: !requireSelectCustomerOnSignIn,
        displayChangeCustomerLink,
        fulfillmentLabel:addressLabel,
        getState: () => state,
        currentRegion,
    };
};

const mapDispatchToProps = {
    loadBillTos,
    loadShipTos,
    selectBillTo,
    selectShipTo,
    setAsDefault,    
    loadBillTo,  
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AddressDrawerSelectCustomerContainerStyles {
    container?: GridContainerProps;
    billToGridItem?: GridItemProps;
    billToGridItemFulfillmentLabel?: GridItemProps;
    billToSelector?: ChangeCustomerBillToSelectorStyles;
    shipToGridItem?: GridItemProps;
    shipToSelector?: ChangeCustomerShipToSelectorStyles;
    isDefaultGridItem?: GridItemProps;
    isDefaultCheckboxGroup?: CheckboxGroupComponentProps;
    isDefaultCheckbox?: CheckboxPresentationProps;
}

export const addressDrawerSelectCustomerContainerStyles: AddressDrawerSelectCustomerContainerStyles = {
    billToGridItem: { width: 12 },
    shipToGridItem: { width: 12 },
    isDefaultGridItem: { width: 12 },
};

const AddressesSelectCustomerContainer = ({
    billTosParameter,
    setBillTosParameter,
    shipTosParameter,
    setShipTosParameter,
    selectedBillTo,
    selectedShipTo,
    billTosDataView,
    shipTosDataView,
    fulfillmentMethod,
    enableWarehousePickup,
    allowCreateNewShipToAddress,
    isDefault,
    loadBillTos,
    loadShipTos,
    selectBillTo,
    selectShipTo,
    setAsDefault,
    extendedStyles,
    showIsDefaultCheckbox,
    displayChangeCustomerLink,
    fulfillmentLabel,    
    loadBillTo,
    currentRegion,
}: Props) => {
    const [styles] = useState(() => mergeToNew(addressDrawerSelectCustomerContainerStyles, extendedStyles));
    const [shipToSearchText, setShipToSearchText] = useState("");  
    const [isCustomSoldTo, setIsCustomSoldTo] = useState(false);  
    const [soldTo, setSoldTo]=useState(""); 
    const [selectDanaBillTo,setSelectDanaBillTo] = useState<BillToModel>();

    const [noShipToAndCantCreate, setNoShipToAndCantCreate] = useState<boolean>(
        !allowCreateNewShipToAddress && !shipToSearchText && shipTosDataView.value?.length === 0,
    );

    useEffect(() => {
        setNoShipToAndCantCreate(
            !allowCreateNewShipToAddress && !shipToSearchText && shipTosDataView.value?.length === 0,
        );
    }, [allowCreateNewShipToAddress, shipToSearchText, shipTosDataView]);

    useEffect(() => {
        billTosParameter.additionalQueryStringParameters = {
            "isAllCustomer": true
        }                
        
        if (!billTosDataView.value && !billTosDataView.isLoading) {
            
            loadBillTos(billTosParameter);
        }
    }, [billTosParameter, billTosDataView]);

    useEffect(() => {
        if (selectedBillTo && !shipTosDataView.isLoading) {
            shipTosParameter.additionalQueryStringParameters = {
                "isBillToData": true
            }
            loadShipTos(shipTosParameter);                   
        }
    }, [shipTosParameter]);  
    
    const billToSelectedHandler = (billTo: BillToModel) => {
        setSelectDanaBillTo(billTo);        
        setCookie("selectBillLa",billTo?.id.toString());
        setCookie("danasoldid","");
        if(billTo?.properties?.multipleSoldToAvl?.toLowerCase()==="true")
        {
                setIsCustomSoldTo(true);
                setShipTosParameter({
                ...shipTosParameter,
                billToId: billTo.id,
                });
        }  
        if(billTo?.properties?.parentId!==undefined && billTo?.properties?.parentId!=="")
        {  
            if(billTo?.properties?.parentisSoldTo?.toLowerCase()==="true"){
                setSoldTo(billTo?.properties?.parentId); 
                setCookie("danasoldid",billTo?.properties?.parentId.toString());
            }
            let billToDataId ='';
            if(billTo?.properties?.parentisBillTo?.toLowerCase()==="true"){
                billToDataId = billTo?.properties?.parentId;
            }else if(billTo?.properties?.parentparentBillToId!==undefined && billTo?.properties?.parentparentBillToId!==""){
                billToDataId = billTo?.properties?.parentparentBillToId;
            }  
                    const billToFromBillTo: BillToModel = {
                        id: billToDataId,
                        properties: {},
                        address1: "1",
                        address2: "",
                        address3: "",
                        address4: "",
                        attention: "",
                        budgetEnforcementLevel: "",
                        city: "",
                        companyName: "",
                        contactFullName: "",
                        costCodeTitle: "",
                        country: null,
                        customerCurrencySymbol: "",
                        customerName: "",
                        customerNumber: "",
                        customerSequence: "",
                        email: "",
                        fax: "",
                        firstName: "",
                        fullAddress: "",
                        isDefault: false,
                        isGuest: false,
                        label: "",
                        lastName: "",
                        phone: "",
                        postalCode: "",
                        shipTosUri: "",
                        state: null,
                        uri: ""
                    };
                    selectBillTo({ billTo:billToFromBillTo })  
                             
        } 
        else if(billTo?.properties?.isBillTo?.toLowerCase()==="true")
        {
            selectBillTo({ billTo });
        }
        if(billTo?.properties?.isShipTo?.toLowerCase()==="true")
        {
            const shipToFromBillTo: ShipToModel = {
                ...billTo,
                isNew: false,
                isVmiLocation: false,
                oneTimeAddress: false,
                validation: null,          
                properties: {},
            };
            selectShipTo({ shipTo: shipToFromBillTo });
        }
        if((currentRegion===LARegion || currentRegion===EMEARegion) && billTo?.properties?.isShipTo?.toLowerCase()==="false")
        {
            const shipToFromBillToLA: ShipToModel = {
                id: billTo?.properties?.shipToIdForLa,
                properties: {},
                address1: "1",
                address2: "",
                address3: "",
                address4: "",
                attention: "",
                city: "",
                companyName: "",
                contactFullName: "",
                country: null,
                customerName: "",
                customerNumber: "",
                customerSequence: "",
                email: "",
                fax: "",
                firstName: "",
                fullAddress: "",
                isDefault: false,
                label: "",
                lastName: "",
                phone: "",
                postalCode: "",
                state: null,
                uri: "",
                isNew: false,
                isVmiLocation: false,
                oneTimeAddress: false,
                validation: null
            };   
            selectShipTo({ shipTo: shipToFromBillToLA });
        }
        if(billTo?.properties?.isSoldTo?.toLowerCase()==="true")
        {
            setSoldTo(billTo.id);           
        }
        setAsDefault({ isDefault: true });            
    };

    const shipToSelectedHandler = (shipTo: ShipToModel) => {
        if(shipTo?.properties?.isShipTo?.toLowerCase()==="true")
        {                
            selectShipTo({ shipTo });
        }
        if(shipTo?.properties?.isSoldTo?.toLowerCase()==="true")
        {
            setSoldTo(shipTo.id); 
        }
        if(shipTo?.properties?.parentId!==undefined && shipTo?.properties?.parentId!=="")
        {  
                const billToFromBillTo: BillToModel = {
                    id: shipTo?.properties?.parentId,
                    properties: {},
                    address1: "",
                    address2: "",
                    address3: "",
                    address4: "",
                    attention: "",
                    budgetEnforcementLevel: "",
                    city: "",
                    companyName: "",
                    contactFullName: "",
                    costCodeTitle: "",
                    country: null,
                    customerCurrencySymbol: "",
                    customerName: "",
                    customerNumber: "",
                    customerSequence: "",
                    email: "",
                    fax: "",
                    firstName: "",
                    fullAddress: "",
                    isDefault: false,
                    isGuest: false,
                    label: "",
                    lastName: "",
                    phone: "",
                    postalCode: "",
                    shipTosUri: "",
                    state: null,
                    uri: ""
                };
                selectBillTo({ billTo:billToFromBillTo })                  
            } else if(shipTo?.properties?.isBillTo?.toLowerCase()==="true")
            {
                const billToFromShipTo: BillToModel = {
                    ...shipTo,
                    validation: null,
                    properties: {},
                    budgetEnforcementLevel: "",
                    costCodeTitle: "",
                    customerCurrencySymbol: "",
                    isGuest: false,
                    shipTosUri: ""
                }; 
                selectBillTo({ billTo:billToFromShipTo })
            }  
            setAsDefault({ isDefault: true });     
    }; 
   
    return (
        <GridContainer {...styles.container}>
            {fulfillmentLabel && (
                <GridItem {...styles.billToGridItemFulfillmentLabel} className="bill-to-grid-item-fullfillment-label">               
                {fulfillmentLabel}
             </GridItem>
            )}             
            <GridItem {...styles.billToGridItem}>
                <ChangeCustomerBillToSelector
                    billTo={selectDanaBillTo!==undefined?selectDanaBillTo:selectedBillTo}
                    onSelect={billToSelectedHandler}
                    parameter={billTosParameter}
                    setParameter={setBillTosParameter}
                    noShipToAndCantCreate={noShipToAndCantCreate}
                    extendedStyles={styles.billToSelector}
                    isLoading={billTosDataView.isLoading}
                />
            </GridItem>     
    {isCustomSoldTo && selectedBillTo && !noShipToAndCantCreate && (
                <>
                    <GridItem {...styles.shipToGridItem}>
                        <ChangeCustomerShipToSelector
                            shipTo={selectedShipTo}
                            onSelect={shipToSelectedHandler}
                            parameter={shipTosParameter}
                            setParameter={setShipTosParameter}
                            searchText={shipToSearchText}
                            setSearchText={setShipToSearchText}
                            enableWarehousePickup={enableWarehousePickup}
                            fulfillmentMethod={fulfillmentMethod}
                            billToId={selectedBillTo.id}
                            extendedStyles={styles.shipToSelector}
                            isLoading={shipTosDataView.isLoading}
                        />
                    </GridItem>
                 
                </>
            )}
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressesSelectCustomerContainer);